import { Typography } from "antd";
import { useSelector } from "react-redux";

import { stateGlobal } from "../../../../../../interfaces/Global";

interface IProps {
    descricao: string;
    count: number | undefined;
    badgeBackgroundColor?: string;
    badgeTextColor?: string;
}

export default function TabTitleCount({
    descricao,
    count,
    badgeBackgroundColor,
    badgeTextColor,
}: IProps) {
    const propsState = useSelector((state: stateGlobal) => state.global);

    const defaultBackgroundColor = (propsState.theme === 'light' ? '#f0f2f5' : "#1D1D1D");
    const backgroundColor = !count ? defaultBackgroundColor : (badgeBackgroundColor || defaultBackgroundColor);
    const textColor = !count ? undefined : badgeTextColor;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
            }}
        >
            <span>{descricao}</span>

            {
                count !== undefined && (
                    <div
                        style={{
                            minWidth: 18,
                            minHeight: 18,
                            borderRadius: 18,
                            backgroundColor: backgroundColor,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 2px'
                        }}
                    >
                        <Typography.Text
                            style={{
                                fontSize: 10,
                                color: textColor,
                                margin: 0,
                                lineHeight: '12px',
                                fontWeight: 600,
                            }}
                        >
                            {count >= 100 ? '99+' : count}
                        </Typography.Text>
                    </div>
                )
            }
        </div>
    )
}
